/**
 * Country choices for a phone number: "India (+91)" in the list, so it can be
 * searched by name or code, and "IN (+91)" in the box once picked.
 */

let regionNames: Intl.DisplayNames | null | undefined;

function countryName(code: string): string {
  if (regionNames === undefined) {
    try {
      regionNames = new Intl.DisplayNames(["en"], { type: "region" });
    } catch {
      regionNames = null;
    }
  }
  try {
    return regionNames?.of(code) ?? code;
  } catch {
    return code;
  }
}

export function countryOptions(countries: Array<{ code: string; callingCode: string }>) {
  return countries.map((c) => ({
    value: c.code,
    text: `${countryName(c.code)} (+${c.callingCode})`,
    selectedText: `${c.code} (+${c.callingCode})`,
  }));
}
